module.exports = __webpack_public_path__ + "img/stars-foff.84248d86.jpg";